import React, { PropsWithChildren, ReactNode } from 'react';

type PagePublicationInfo = PropsWithChildren<{
  headline: string;
  children: ReactNode;
}>;

export function PagePublicationInfo({ children, headline }: PagePublicationInfo) {
  return (
    <div className="page-publication-info">
      <h2 className="invisible">{headline}</h2>
      {children}
    </div>
  );
}
